// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3O-Vo","inner":"Footer_inner__3R6wI"};